// import defaultSettings from '@/settings'
import i18n from '../lang'
import { isMy } from './constant'

// 同步title
export default function getPageTitle(pageTitle) {
  //  检查 key 是否存在
  const hasKey = i18n.te('route.' + pageTitle)
  let title = i18n.t('settings.title')

  if (!isMy()) {
    title = replaceABX(title)
  }

  if (hasKey) {
    const translatedTitle = i18n.t('route.' + pageTitle)
    return `${translatedTitle} - ${title}`
  }
  return title
}

function replaceABX(str) {
  return str.replace('ABX', 'KEX')
}
